export const learnProductName = 'Learn'
